import { FormControl, MenuItem, Select } from '@mui/material';
import scssVariables from '../../../../Config.module.scss';
import { EventActionsEnum, EventCategoriesEnum } from '../../../Services/Logging/DataLayerDefinitions';
import loggingService from '../../../Services/Logging/LoggingService';
import styles from './Inputs.module.scss';

interface IMuiDropdownProps {
    value?: string;
    options: string[];
    handleOptionChange: (value: string) => void;
    label?: string | JSX.Element;
    testId?: string;
}

const ColorSelectorDropdown = (props: IMuiDropdownProps): JSX.Element => {
    const handleOptionChange = (selection: string): void => {
        loggingService.trackEventWithAnalytics(EventActionsEnum.DropdownSelection, EventCategoriesEnum.DropdownSelected, `${selection}`, `${props.label}`);
        props.handleOptionChange(selection);
    };

    return (
        <div data-testid={props.testId} className={styles.input_dropdown_flex}>
            {props.label && <p className={styles.input_dropdown_label}>{props.label}</p>}
            <FormControl style={{ display: 'flex' }} className={styles.input_line_color_block} fullWidth sx={{ m: 1, margin: 0 }} size="small">
                <Select
                    className={`${styles.input_base_dropdown}`}
                    value={props.options.find((x) => x === props.value) ?? ''}
                    onChange={(event) => handleOptionChange(event.target.value as string)}
                    onOpen={() => {
                        loggingService.trackEventWithAnalytics(
                            EventActionsEnum.DropdownSelection,
                            EventCategoriesEnum.DropdownOpened,
                            `${props.value}`,
                            `${props.label}`,
                        );
                    }}
                    onClose={() => {
                        loggingService.trackEventWithAnalytics(EventActionsEnum.DropdownSelection, EventCategoriesEnum.DropdownClosed, '', `${props.label}`);
                    }}
                    sx={{
                        backgroundColor: props.value,
                        height: 40,
                        width: 40,
                        outline: 'none',
                        padding: 0,
                        '& .css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
                            padding: 0,
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '& svg': {
                            visibility: 'hidden',
                        },
                        fontFamily: scssVariables.fontFamily,
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 400,
                                borderRadius: 4,
                                padding: 0,
                            },
                        },

                        MenuListProps: {
                            sx: {
                                display: 'flex',
                                width: 300,
                                flexWrap: 'wrap',
                            },
                        },
                    }}
                >
                    {props.options.map((option) => (
                        <MenuItem
                            key={`${option}`}
                            value={`${option}`}
                            sx={[
                                { fontFamily: scssVariables.fontFamily },
                                { '&.Mui-selected': { backgroundColor: scssVariables.stonexSkyBlue } },
                                { '&:hover': { backgroundColor: scssVariables.deactivatedBlockColor } },
                            ]}
                            data-testid={option}
                        >
                            <div style={{ backgroundColor: option ?? undefined }} className={styles.input_line_color_block} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};

export default ColorSelectorDropdown;
